export const errorMessage = {
    ballTypeValueErrorMessage: 'Event must be verified for this ball type.',
    eventTypeErrorMessage: 'Event must be verified for your selected division ball type.',
    cappedDivisionFullMessage: 'Division is full. For any questions, please contact the event organizer.',
    passwordUpdateFailedErrorMessage: 'Unable to Update Password. Please check password requirements before trying again. If you require further assistance please contact customer support',
    dinglesVerifiedErrorMessage: 'Event cannot be verified with a Dingles division game type.',
};
